export const FINANCE_VIEWS = [
  "profit",
  "planned",
  "staff",
  "bank",
  "cards",
  "tax",
  "matching",
  "reconciliation",
] as const;

export type FinanceView = (typeof FINANCE_VIEWS)[number];

function isFinanceView(value: string | null): value is FinanceView {
  return FINANCE_VIEWS.some((view) => view === value);
}

function splitHash(hash: string) {
  const queryIndex = hash.indexOf("?");
  return {
    path: queryIndex === -1 ? hash : hash.slice(0, queryIndex),
    query: queryIndex === -1 ? "" : hash.slice(queryIndex + 1),
  };
}

export function financeViewForRoute(route: string, hash: string): FinanceView {
  if (route === "banking") return "bank";
  if (route === "tax") return "tax";
  if (route === "payroll") return "staff";
  if (route === "finance") {
    const view = new URLSearchParams(splitHash(hash).query).get("view");
    if (isFinanceView(view)) return view;
  }
  return "profit";
}

export function financeHashForView(hash: string, view: FinanceView): string {
  const { path, query } = splitHash(hash);
  if (path.replace(/^#\/?/, "") !== "finance") return hash;
  const params = new URLSearchParams(query);
  params.set("view", view);
  return `${path}?${params.toString()}`;
}
